import { ElMessage } from 'element-plus'
import { defineStore } from 'pinia'
import {
    login,
    login_out,
    getHotProduct,
    getHelp,
    getIndexInfo,
    getOrderStatistics,
    loginLog,
    getAuthenticationInfo,
    addSaveInfo,
    addEnterpriseSaveInfo,
    addEnterpriseSaveUploadimg,
    rechargeOrder,
    rechargeList,
    myBill,
    myBillDetails,
    userInfo,
    userDetail,
    getChildAccount,
    addChildAccount,
    delChildAccount,
    editChildAccount,
    getAddressList,
    addAndUpdateAddress,
    delAddress,
    delPdf,
    getArea, addAddress,
    getGlobalArea,
    isRechargeOrderPaid,
} from '../service/api'
import { setCookie, checkCookie } from '../utils/cookie'
import dayjs from 'dayjs'
// import QRCode  from './qrcode.js'

export interface Address {
    adddress_id: number,
    address_detail: string,
    addtime: number,
    aid: number,
    city: string,
    city_name: string,
    cityid: number,
    country_id: number,
    county: string,
    mo: number,
    page: number,
    phone: number,
    province: number,
    provinceid: number,
    tel: string,
    uid: number,
    uname: string,
    xian: string,
    xianid: number,
    zipcode: string
}

export const useCounterStore = defineStore('counter', {
    state: () => {
        return {
            userInfo: {
                uid: 0,
                group_id: 0,
                balance: 0,
                guan_zhu_id: 0,
                username: '',
                phone: 0,
                jifen: 0,
                level: 0,
                account_id: 0,
                uids: 0
            },
            loginVisible: false,
            token: localStorage.getItem('token') || '',
            total: 0,
            total2: 0,
            occountList: <any>[],
            addressList: <Address[]>[],
            loginList: <any>[],
            rechargeListArr: <any>[],
            myBillData: <any>[],
            myBillDataList: <any>[],
            saveinfo: <any>{},
            enterprise_info: null,
            place: '',
            time: '',
            hotList: <any>[],
            newList: <any>[],
            helpList: <any>{},
            indexInfo: <any>{
                "day_money": 0,//今日营业额
                "day_order_count": 0,//今日订单数
                "day_order_num": 0,//今日订单件数
                "yestday_money": 0,//昨天营业额
                "yestday_order_count": 0,//昨天订单数
                "yestday_order_num": 0,//昨天订单件数
                "week_money": 0,//本周营业额
                "week_order_count": 0,//本周订单数
                "week_order_num": 0,//本周订单件数
                "daifukuan_count": 0,//待付款总数
                "daisheji_count": 0,//待设计总数
                "daiquren_count": 0,//待确认总数
                "gezhizhong_count": 0,//搁置中总数
                "shouhou_count": 0//售后总数
            },
            statisticsList: <Record<number, Record<string, any>>>{},
            qrCodeUrl: '',
        }
    },
    getters: {
        isLogin() {
            if (!checkCookie('PHPSESSID') || !localStorage.getItem('token')) {
                return false
            }
            return true
        },
        userText() {
            let text = ''
            if (this.userInfo.group_id == 2) {
                text = "工厂会员"
            } else if (this.userInfo.group_id == 3) {
                text = "内部会员"
            } else if (this.userInfo.level == 1) {
                text = "普通会员"
            } else if (this.userInfo.level == 2) {
                text = "VIP会员"
            } else if (this.userInfo.level == 3) {
                text = "SVIP会员"
            }
            return text
        },
    },
    actions: {
        login: async function (params: any) {
            const { code, data, msg = '网络繁忙，请稍后再试！' } = await login(params) || {}
            const { token } = data || {}
            if (code == 100) {
                if (token && token != '') {
                    localStorage.setItem('token', token)
                    setCookie('PHPSESSID', token, 30)
                    location.href = '/mt'
                }
            } else {
                ElMessage({
                    message: msg || '网络繁忙，请稍后再试',
                    type: 'warning'
                })
            }
        },
        loginLog: async function ({ page = 1, ip = false }) {
            try {
                const { code, data: dt = {}, msg = '' } = await loginLog({ page }) || {}

                if (code == 100) {
                    this.total = dt.length
                    this.loginList = dt
                    if (dt.length > 0 && ip) {
                        this.place = dt[0].area ? dt[0].ip + '-' + dt[0].area : dt[0].ip
                        this.time = dayjs(dt[0].time * 1000).format("YYYY-MM-DD HH:mm:ss")
                    }
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('loginLog:', e)
            }
        },
        getAuthenticationInfo: async function () {
            try {
                const { code, user: dt = {}, info = null, msg = '' } = await getAuthenticationInfo() || {}

                if (code == 100) {
                    this.saveinfo = dt
                    this.enterprise_info = info
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('getAuthenticationInfo:', e)
            }
        },
        addSaveInfo: async function ({ username = '', card_id = '' }) {
            try {
                const { code, msg = '' } = await addSaveInfo({ username, card_id }) || {}

                if (code == 100) {
                    ElMessage({
                        message: msg || '实名认证成功',
                        type: 'success'
                    })
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('addSaveInfo:', e)
            }
        },
        getHotProduct: async function ({ type = '', limit = 10 }) {
            try {
                const { code, msg = '', data } = await getHotProduct({ type, limit }) || {}

                if (code == 100) {
                    const arr = data.filter((item: any) => item.feng_thumb)
                    const d = <any>[]
                    if (type == 'hot') {
                        this.hotList.length = 0
                    } else if (type == 'new') {
                        this.newList.length = 0
                    }
                    arr.forEach((item: any, index: number) => {
                        d.push(item)
                        if ((index + 1) % 5 == 0 || index + 1 == arr.length) {
                            if (type == 'hot') {
                                this.hotList.push([...d])
                            } else if (type == 'new') {
                                this.newList.push([...d])
                            }
                            d.length = 0
                        }
                    })
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('getHotProduct:', e)
            }
        },
        getHelp: async function () {
            try {
                const { code, msg = '', data } = await getHelp() || {};
                if (code === 100) {
                    const categories = ['all', 'blog', 'information', 'faq'];
                    categories.forEach((category) => {
                        if (data[category]) {
                            const list: Array<{ time: string, type: string, title: string, url: string }> = [];
                            data[category].forEach((im: any) => {
                                if (im.date) {
                                    let dateObj;
                                    try {
                                        dateObj = dayjs(im.date);
                                        if (!dateObj.isValid()) {
                                            dateObj = dayjs(im.date, 'YYYY-MM-DD');
                                        }
                                    } catch (error) {
                                        dateObj = dayjs(); // 若还是失败，设置为当前时间
                                    }
                                    list.push({
                                        time: dateObj.format("YYYY-MM-DD HH:mm:ss"),
                                        type: category,
                                        title: im.title,
                                        url: im.url || `/index/help/shownews/id/${im.id}/aid/${im.aid}.html`, // 使用返回的url，如果没有则用默认拼接
                                    });
                                } else {
                                    list.push({
                                        time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 没有date字段时，设置为当前时间
                                        type: category,
                                        title: im.title,
                                        url: im.url || `/index/help/shownews/id/${im.id}/aid/${im.aid}.html`,
                                    });
                                }
                            });
                            this.helpList[category] = list;
                        }
                    });
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    });
                }
            } catch (e) {
                console.log('getHelp:', e);
            }
        },
        getIndexInfo: async function () {
            try {
                const { code, msg = '', data } = await getIndexInfo() || {}

                if (code == 100) {
                    this.indexInfo = data
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('getIndexInfo:', e)
            }
        },
        getOrderStatistics: async function (params: { source?: number, type?: number } & Record<string, any> = { source: 4, type: 1 }) {
            try {
                const { source = 4, type = 1, ...rest } = params || {}
                const extraKey = Object.keys(rest)
                    .sort()
                    .map((k) => `${k}:${rest[k]}`)
                    .join('|')
                const key = extraKey ? `${type}_${extraKey}` : `${type}`
                if (this.statisticsList[source]?.[key]) {
                    return this.statisticsList[source][key]
                }
                const { code, msg = '', data } = await getOrderStatistics({ source, type, ...rest }) || {}

                if (code == 100) {
                    if (!this.statisticsList[source]) {
                        this.statisticsList[source] = {}
                    }
                    this.statisticsList[source][key] = data
                    return data
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('getOrderStatistics:', e)
            }
            return null
        },
        addEnterpriseSaveInfo: async function ({ enterprise_name = '', enterprise_code = '', corporate_tel = '', imgs = '' }: { enterprise_name: string, enterprise_code: string, corporate_tel: string, imgs: any }) {
            try {
                const { code, data: dt, msg = '' } = await addEnterpriseSaveInfo({ enterprise_name, enterprise_code, corporate_tel, imgs }) || {}

                if (code == 100) {
                    // this.rechargeListArr = dt
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('addEnterpriseSaveInfo:', e)
            }
        },
        addEnterpriseSaveUploadimg: async function ({ file = '' }) {
            try {
                const { status, path } = await addEnterpriseSaveUploadimg({ file }) || {}

                if (status == 1) {
                    return { suc: 'true', file: path }
                } else {
                    ElMessage({
                        message: '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('addEnterpriseSaveUploadimg:', e)
            }
        },
        rechargeOrder: async function ({ money = 0, type = '' }) {
            try {
                const { code, msg = '', data: data } = await rechargeOrder({ money, type }) || {}
                if (code == 101) {
                    this.qrCodeUrl = data.code_url
                    return { code: 101, data: data }
                } else if (code == 102) {
                    return { code: 102, data: data }
                } else {
                    ElMessage.error(msg)
                }
            } catch (e) {
                console.log('rechargeOrder:', e)
            }
        },
        isRechargeOrderPaid: async function ({ orderId = '' }) {
            try {
                const { data } = await isRechargeOrderPaid({ orderId }) || {}
                return { data: data }
            } catch (e) {
                console.log('isRechargeOrderPaid:', e)
            }
        },
        rechargeList: async function () {
            try {
                const { code, data: dt, msg = '' } = await rechargeList() || {}

                if (code == 100) {
                    this.rechargeListArr = dt
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('rechargeList:', e)
            }
        },
        myBill: async function (params?: any) {
            try {
                const { code, data: dt, msg = '' } = await myBill({ ...params }) || {}

                if (code == 100) {
                    this.myBillData = dt
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('myBillData:', e)
            }
        },
        myBillDetails: async function (params?: any) {
            try {
                const { code, data: dt, msg = '' } = await myBillDetails({ ...params }) || {}

                if (code == 100) {
                    this.myBillDataList = dt
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('myBillData:', e)
            }
        },
        getAddressList: async function ({ page = 1 }) {
            try {
                const { code, data: { data: dt = [], recordsTotal = 0 } = {}, msg = '' } = await getAddressList({ page }) || {}

                if (code == 100) {
                    this.total2 = recordsTotal
                    this.addressList = dt
                } else throw new Error(msg);
            } catch (e) {
                console.log('getAddressList:', e)
                ElMessage({
                    message: (e as Error).message || '网络繁忙，请稍后再试',
                    type: 'warning'
                })
            }
        },
        async getAddressPage({page = 1}): Promise<boolean> {
            try {
                const { code, data: { data: dt = [], recordsTotal = 0 } = {}, msg = '' } = await getAddressList({ page }) || {}

                if (code == 100) {
                    this.total2 = recordsTotal
                    // console.log(dt);
                    this.addressList = this.addressList.concat(dt);
                    return dt.length > 0;
                } else throw new Error(msg);
            } catch (e) {
                console.log('getAddressList:', e)
                ElMessage({
                    message: (e as Error).message || '网络繁忙，请稍后再试',
                    type: 'warning'
                })
            }
            return false;
        },
        async clearAddressPage() {
            this.addressList = [];
        },
        addAndUpdateAddress: async function ({ saveid = '', province = '', city = '', xian = '', zipcode = '', address_detail = '', uname = '', tel = '', country = '', city_name = '' }) {
            try {
                const payload = { saveid, province, city, xian, zipcode, address_detail, uname, tel, country, city_name }
                const { code, data = {}, msg } = await addAndUpdateAddress(payload as any) || {}

                if (code == 100) {
                    ElMessage({
                        message: msg || '保存成功',
                        type: 'success'
                    })
                    return { suc: "true" }
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('addAndUpdateAddress:', e)
            }
        },

       addAddress: async function ({ saveid = '', province = '', city = '', xian = '', zipcode = '', address_detail = '', uname = '', tel = '', country = '' }) {
            try {
                const payload = { saveid, province, city, xian, zipcode, address_detail, uname, tel, country }
                const { code, data = {}, msg } = await addAddress(payload as any) || {}

                if (code == 100) {
                    ElMessage({
                        message: msg || '保存成功',
                        type: 'success'
                    })
                    return { suc: "true" }
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('addAndUpdateAddress:', e)
            }
        },
        delAddress: async function ({ aid = '' }) {
            try {
                const { code, data = {}, msg } = await delAddress({ aid }) || {}

                if (code == 100) {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'success'
                    })
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('delAddress:', e)
            }
        },
        delPdf: async function () {
            try {
                const { code, data = {}, msg } = await delPdf() || {}
            } catch (e) {
                console.log('delPdf:', e)
            }
        },
        getArea: async function ({ aid = 0 }) {
            try {
                const data = await getArea({ aid }) || {}

                return data
            } catch (e) {
                console.log('getArea:', e)
            }
        },
        getGlobalArea: async function ({ aid = 0, countryId = 0, zid = 0, cid = 0 }) {
            try {
                const data = await getGlobalArea({ aid, countryId, zid, cid }) || {}

                return data
            } catch (e) {
                console.log('getGlobalArea:', e)
            }
        },
        getChildAccount: async function ({ page = 1 }) {
            try {
                const { code, data: { data: dt = [], recordsTotal = 0 } = {}, msg = '' } = await getChildAccount({ page }) || {}

                if (code == 100) {
                    this.total = recordsTotal
                    this.occountList = dt
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('getChildAccount:', e)
            }
        },
        addChildAccount: async function ({ uname = '', pwd = '', remarks = '' }) {
            try {
                const { code, data = {}, msg } = await addChildAccount({ uname, pwd, remarks }) || {}

                if (code == 100) {
                    ElMessage({
                        message: msg || '保存成功',
                        type: 'success'
                    })
                    return { suc: "true" }
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('addChildAccount:', e)
            }
        },
        editChildAccount: async function ({ saveid = '', pwd = '', remarks = '' }) {
            try {
                const { code, data = {}, msg } = await editChildAccount({ saveid, pwd, remarks }) || {}

                if (code == 100) {
                    ElMessage({
                        message: msg || '保存成功',
                        type: 'success'
                    })
                    return { suc: 'true' }
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('editChildAccount:', e)
            }
        },
        delChildAccount: async function ({ did = '' }) {
            try {
                const { code, data = {}, msg } = await delChildAccount({ did }) || {}

                if (code == 100) {
                    ElMessage({
                        message: msg || '删除成功',
                        type: 'success'
                    })
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.log('delChildAccount:', e)
            }
        },
        login_out: async function () {
            const { code, data = {}, msg } = await login_out({ token: this.token })
            console.log(data);
            if (code == 100) {
                const { url } = data
                location.href = url
            }
        },
        getUserInfo: async function () {
            try {
                const { code, data = {}, msg } = await userInfo({ token: this.token }) || {}

                if (code == 100) {
                    const { group_id, level, progress, target, uid, uname, token, guan_zhu_id } = data
                    this.userInfo.group_id = group_id
                    this.userInfo.level = level
                    this.userInfo.uid = uid
                    this.userInfo.uids = uid
                    this.userInfo.guan_zhu_id = guan_zhu_id
                    if (!this.token && token) {
                        localStorage.setItem('token', token)
                        // setCookie('PHPSESSID', token, 30)
                        // location.href = '/mt'
                    }

                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                    if (code == 500) {
                        localStorage.removeItem('token');
                        const { url } = data
                        location.href = url;
                    }
                }
            } catch (e) {
                console.log('getUserInfo:', e)
            }
        },
        getUserDetail: async function () {
            try {
                // if(!this.token)return 'login'
                const { code, data = {}, msg } = await userDetail({ token: this.token }) || {}
                if (code == 100) {
                    const { balance, username, phone, group_id, jifen, account_id, token } = data || {}
                    this.userInfo = Object.assign(this.userInfo, { balance, username, phone, group_id, jifen, account_id })
                    if (!this.token && token) {
                        localStorage.setItem('token', token)
                        // location.href = '/mt'
                    }
                } else {
                    ElMessage({
                        message: msg || '网络繁忙，请稍后再试',
                        type: 'warning'
                    })
                    if (code == 500) {
                        const { url } = data
                        location.href = url;
                    }
                }
            } catch (e) {
                console.log('getUserDetail:', e)
            }
        }
    }
})